import { render, staticRenderFns } from "./CalendarioAcademiconew.vue?vue&type=template&id=7c05c2ff&scoped=true"
import script from "./CalendarioAcademiconew.vue?vue&type=script&lang=js"
export * from "./CalendarioAcademiconew.vue?vue&type=script&lang=js"
import style0 from "./CalendarioAcademiconew.vue?vue&type=style&index=0&id=7c05c2ff&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c05c2ff",
  null
  
)

export default component.exports